import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import usersReducer from './usersReducer';
import domainsReducer from './domainsReducer';
import collectionsReducer from './collectionsReducer';
import notificationReducer from './notificationReducer';
import treeReducer from './treeReducer';
import localDomains from './localDomainsReducer';
import agentsReducer from './agentsReducer';
import { ADapi } from '../services/ADapi';

export const store = configureStore({
  reducer: {
    users: usersReducer,
    collections: collectionsReducer,
    notification: notificationReducer,
    domains: domainsReducer,
    tree: treeReducer,
    localDomains: localDomains,
    agents: agentsReducer,
    [ADapi.reducerPath]: ADapi.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(ADapi.middleware);
  },
});

setupListeners(store.dispatch);
